/* eslint-disable */ 
import ThemeBox from "./ThemeBox";

export type * as TB from "./ThemeBox";

export default ThemeBox;
